<div class="content-container">
  <section class="data-table invoice">
    <header class="data-table__header">
      <h2 class="page-heading">
        <svg width="30" height="37" viewBox="0 0 30 37">
          <path fill-rule="evenodd" d="M26.465 36.059H3.212c-1.688 0-3.061-1.383-3.061-3.082V3.537c0-1.7 1.373-3.082 3.06-3.082h23.254c1.687 0 3.06 1.382 3.06 3.082v29.44c0 1.7-1.373 3.082-3.06 3.082zM3.212 1.754c-.977 0-1.771.799-1.771 1.783v29.44a1.78 1.78 0 0 0 1.77 1.783h23.254c.977 0 1.77-.8 1.77-1.783V3.537c0-.984-.793-1.783-1.77-1.783H3.212zm4.826 8.234h-.016a.641.641 0 0 1-.452-.2L6.018 8.135a.589.589 0 0 1 .047-.854.647.647 0 0 1 .89.044l1.107 1.18 2.996-2.878a.648.648 0 0 1 .89 0 .588.588 0 0 1 0 .855L8.484 9.811a.642.642 0 0 1-.445.177zm16.55-.567h-9.504c-.37 0-.668-.255-.668-.568 0-.313.298-.567.668-.567h9.505c.368 0 .668.254.668.567 0 .313-.3.568-.668.568zm-16.55 7.375h-.016a.641.641 0 0 1-.452-.2l-1.552-1.652a.589.589 0 0 1 .047-.855.647.647 0 0 1 .89.044l1.107 1.18 2.996-2.878a.648.648 0 0 1 .89 0 .588.588 0 0 1 0 .855L8.484 16.62a.642.642 0 0 1-.445.177zm16.55-1.134h-9.504c-.37 0-.668-.255-.668-.568 0-.313.298-.567.668-.567h9.505c.368 0 .668.254.668.567 0 .313-.3.568-.668.568zm-.551 6.808H6.506c-.358 0-.65-.254-.65-.567 0-.314.292-.568.65-.568h17.53c.36 0 .65.254.65.568 0 .313-.29.567-.65.567zm.005 6.24H6.501c-.356 0-.644-.253-.644-.566 0-.314.288-.568.644-.568h17.541c.356 0 .644.254.644.568 0 .313-.288.567-.644.567z"/>
        </svg>
        <ng-container i18n="@@proposals">Proposals</ng-container>
      </h2>
      <!-- data-table__heading -->
    </header>
    <!-- end billing-header -->
    
    <div class="data-table__wrap">
      <header class="data-table__controls">
        <ng-container *ngIf="['create-proposal', 'edit-proposal', 'view-proposal'].indexOf(activeTab) == -1; else closeProposal">
          <div class="select-date-from">
            <select nice-select (change)="switchTab($event.target.value)" class="select-link" id="tab-links-select">
              <option [value]="'all-proposals'" [selected]="activeTab == 'all-proposals'" i18n="@@proposals.all_proposal">All Proposals ({{ totalProposals }})</option>
              <option [value]="'drafts'" [selected]="activeTab == 'drafts'" i18n="@@proposals.drafts">Drafts ({{ totalDrafts }})</option>
            </select>

            <ul class="nav nav-pills" id="pills-tab" role="tablist">
              <li class="nav-item">
                <a (click)="switchTab('all-proposals')" [class.active]="activeTab =='all-proposals'" class="nav-link" id="pills-all-pill" role="tab" aria-controls="pills-home" aria-selected="true" i18n="@@proposals.all_proposal">All proposals ({{ totalProposals }})</a>
              </li>
              <li class="nav-item">
                <a (click)="switchTab('drafts')" [class.active]="activeTab =='drafts'" class="nav-link" id="pills-draft-pill" role="tab" aria-controls="pills-contact" aria-selected="false" i18n="@@proposals.drafts">Drafts ({{ totalDrafts }}) </a>
              </li>
            </ul>

            <div class="date-from">
              <div class="date-input-wrap">
                <input type="text" date-dropper [(ngModel)]="fromDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.from_date" placeholder="From Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="proposal-date-range" />
              </div>

              <div class="date-input-wrap">
                <input type="text" date-dropper [(ngModel)]="toDate" (onDatePicked)="filterByDate()" data-dd-init-set="false" i18n-placeholder="@@ts.to_date" placeholder="To Date" class="date-input" data-dd-format="d/m/Y" data-dd-roundtrip="proposal-date-range" />
              </div>
            </div>

            <button (click)="resetDateFilters()" class="tu-btn pink clear_btn" i18n="@@common.clear">Clear</button>
          </div>
          
          <div class="data-table__btn-wrap">
            <div class="data-table__mobileMenu" [hidden]="['received-payments'].indexOf(activeTab) !== -1">
              <a href="javascript:;" (click)="toggleTableMenu()" class="hamburger-menu table-menu table-dropdown-trigger">
                <div class="hamburger hamburger--spring">
                    <div class="hamburger-box">
                        <div class="hamburger-inner"></div>
                    </div>
                </div>
              </a>
            </div>

            <div class="download_xl_placeholder" *ngIf="activeTab=='drafts'"></div>

            <a href="/proposals/download" [hidden]="activeTab=='drafts'" class="xl-download" >
              <svg xmlns="http://www.w3.org/2000/svg" width="26" height="25" viewBox="0 0 26 25">
                <g fill="#0CC5D1" fill-rule="evenodd">
                  <path d="M24.375 19.458h-9.75v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438v-1.621h2.438a.812.812 0 1 0 0-1.622h-2.438V8.108h2.438a.812.812 0 1 0 0-1.622h-2.438V4.864h9.75v14.594zM13 22.534L1.625 20.407V3.916L13 1.789v20.745zM25.188 3.243H14.624V.811a.808.808 0 0 0-.962-.796l-13 2.432A.809.809 0 0 0 0 3.243V21.08c0 .389.278.724.663.796l13 2.432a.813.813 0 0 0 .962-.796V21.08h10.563a.812.812 0 0 0 .812-.811V4.054a.812.812 0 0 0-.813-.811z"/>
                  <path d="M20.129 8.387h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 11.892h1.677a.839.839 0 0 0 0-1.678H20.13a.839.839 0 0 0 0 1.678M20.129 14.677h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M20.129 17.463h1.677a.839.839 0 0 0 0-1.677H20.13a.839.839 0 0 0 0 1.677M7.953 12.351l2.681-3.447a.838.838 0 1 0-1.323-1.032l-2.483 3.193-2.092-2.391a.838.838 0 1 0-1.263 1.104l2.306 2.636-2.338 3.007a.84.84 0 0 0 .663 1.353c.248 0 .496-.11.66-.322l2.14-2.752 2.439 2.787a.836.836 0 0 0 1.184.08.837.837 0 0 0 .079-1.183L7.953 12.35z"/>
                </g>
              </svg>
              <span i18n="@@common.download_xls">download .xls</span>
            </a>
            
            <div class="btn-row">
              <form class="data-table__search" [class.open]="isSearch">
                <input type="text" (keyup)="searchProposals($event.target.value)" name="data-table__search--input" i18n-placeholder="@@input.search_here" placeholder="Type Search Here" #searchInput/>
                <a href="javascript:void(0)" id="search-open" (click) = "toggleSearch()">
                  <svg width="20" height="19" viewBox="0 0 20 19">
                    <g class="svg-stroke" fill="none" fill-rule="evenodd" stroke-width="1.5" transform="translate(1 1)">
                      <circle cx="7" cy="7" r="7"/>
                      <path stroke-linecap="square" d="M13.5 12.5L18 17"/>
                    </g>
                  </svg>
                </a>
                <svg id="search-close" width="15" height="15" class="close-icon" version="1.1" x="0px" y="0px" viewBox="0 0 14 14" style="enable-background:new 0 0 14 14;" xml:space="preserve" (click) = "toggleSearch()">
                  <path class="svg-stroke" fill="none" stroke-width="2" stroke-linecap="square" d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5"/>
                </svg>
              </form>
              
              <a (click)="switchTab('create-proposal')" href="javascript:void(0)" id="create-new-proposal-trigger" data-text="X" class="tu-btn-circular pink">
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
                    <path d="M1 7h12M7 1v12"/>
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </ng-container>

        <ng-template #closeProposal>
          <div class="data-table__btn-wrap w-100">
            <div class="btn-row">
              <a (click)="goToPreviousTab()" href="javascript:void(0)" id="create-new-proposal-trigger" data-text="X" class="tu-btn-circular pink clicked">
                <svg width="14" height="14" viewBox="0 0 14 14">
                  <g fill="none" fill-rule="evenodd" stroke="#FFF" stroke-linecap="square" stroke-width="2">
                    <path d="M1 7h12M7 1v12"/>
                  </g>
                </svg>
              </a>
            </div>
          </div>
        </ng-template>
      </header>
      <!-- end header -->
      
      <div *ngIf="['create-proposal', 'edit-proposal', 'view-proposal'].indexOf(activeTab) == -1" class="tab-content data-table__tab-content" id="proposals-tab-content">
        
        <div [class.active]="activeTab == 'all-proposals'" class="tab-pane fade show active" id="pills-proposals" role="tabpanel" aria-labelledby="pills-view-tab">
          <teemapp-table
	          [name]="'proposals'"
	          [tableSchema]="proposalsTable"
	          [selectable]="true"
	          [menuItems]="proposalsMenuItems"
	          (onLoad)="onLoadProposals($event)"
            (onSelect)="onSelectProposals($event)"
	          #proposalsTableRef 
          >
          </teemapp-table>
        </div>
        <!-- End #pill-all-proposals tab -->

        <div [class.active]="activeTab == 'drafts'" class="tab-pane fade show" id="pills-draft" role="tabpanel" aria-labelledby="pills-draft-tab">
          <teemapp-table
	          [name]="'drafts'"
	          [tableSchema]="draftsTable"
	          [selectable]="true"
	          [menuItems]="draftsMenuItems"
	          (onLoad)="onLoadDrafts($event)"
            (onSelect)="onSelectDrafts($event)"
	          #draftsTableRef 
          >
          </teemapp-table>
        </div>
        <!-- End #pill-draft  -->
      </div>
      <!-- End tab-content -->

      <create-proposal 
	      *ngIf="activeTab == 'create-proposal'"
	      (onCreateProposal)="onCreateProposal($event)">
      </create-proposal>
      
      <view-proposal 
	      *ngIf="activeTab == 'view-proposal'"
	      [proposal]="activeProposal"
	      (onEdit)="editProposal($event)"
	      (back)="goToPreviousTab()">
      </view-proposal>
      
      <edit-proposal
	      *ngIf="activeTab == 'edit-proposal'"
	      [proposal]="activeProposal"
	      (onEditProposal)="onEditProposal($event)">
      </edit-proposal>

    </div>
    <!-- end data-table__wrap -->
  </section>
  <!-- end data-table -->
</div>
<!-- end content-container -->